import React from 'react'

import {
  Form,
  Checkbox,
  Input,
  Select,
  Dropdown,
  Button
} from 'semantic-ui-react'

export default ({
  onSubmit,
  isEditMode,
  isEdited,
  username,
  password,
  enabled,
  newPassword,
  newPasswordStatus,
  firstname,
  lastname,
  email,
  role,
  approverId,
  approvers,
  handleChange,
  handlePasswordReset
}) => {
  const approverOptions = [
    {
      id: 0,
      text: 'No Approver',
      value: null
    },
    ...approvers.map(({ username, id }) => {
      return {
        key: id,
        text: username,
        value: id
      }
    })
  ]
  return (
    <Form onSubmit={onSubmit}>
      <Form.Group>
        <Form.Button
          disabled={!isEdited || newPassword}
          positive
          basic
          onClick={onSubmit}
        >
          Save User
        </Form.Button>
         <Form.Field
          control={Checkbox}
          label={enabled ? 'Enabled' : 'Disabled'}
          toggle
          checked={enabled}
          name="enabled"
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Field
          name="username"
          control={Input}
          label="Username"
          value={username}
          placeholder="Username"
          disabled={isEditMode}
          onChange={handleChange}
        />

        {isEditMode
          ? <Form.Field
              name="newPassword"
              action={
                <Button
                  onClick={() => handlePasswordReset()}
                  content={
                    newPasswordStatus ? 'Successful!' : 'Change Password'
                  }
                  disabled={newPasswordStatus || !newPassword}
                  type="button"
                  positive={newPasswordStatus}
                />
              }
              control={Input}
              label="New Password"
              value={newPasswordStatus ? 'Successful!' : newPassword}
              placeholder="New Password"
              type="text"
              onChange={handleChange}
            />
          : <Form.Field
              name="password"
              control={Input}
              label="Password"
              value={isEditMode ? '12345' : password}
              placeholder="Password"
              disabled={isEditMode}
              type="password"
              onChange={handleChange}
            />}

        <Form.Field
          name="role"
          control={Select}
          label="Role"
          value={role ? role : 'user'}
          placeholder="Role"
          options={[
            { key: 0, text: 'User', value: 'user' },
            { key: 1, text: 'Approver', value: 'approver' },
            { key: 2, text: 'Admin', value: 'admin' }
          ]}
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Field
          name="firstname"
          control={Input}
          label="First Name"
          value={firstname}
          placeholder="First Name"
          onChange={handleChange}
        />
        <Form.Field
          name="lastname"
          control={Input}
          label="Last Name"
          value={lastname}
          placeholder="Last Name"
          onChange={handleChange}
        />
        <Form.Field
          name="email"
          control={Input}
          label="Email"
          value={email}
          placeholder="Email"
          type="email"
          onChange={handleChange}
        />
        <Form.Field name="approver" control={Input} label="Approver">
          <Dropdown
            name="approverId"
            placeholder="No Approver"
            search
            selection
            autoComplete
            options={approverOptions}
            value={approverId}
            onChange={handleChange}
          />
        </Form.Field>
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/EditBaseUserForm.jsx